import { DropdownHelper, IDropdownScope } from '../helpers/DropdownHelper';
import { IColumnWidths } from '../models/ColumnWidths';
import { ISliceable } from '../models/ISliceable';
import { Module } from '../Module';

export interface ITypeaheadSource {
  (matchText: string): ISliceable<any>;
}

interface ITypeaheadScope extends IDropdownScope<any, any> {

  // Bound to attributes
  model: any;
  autoEdit: boolean;

  // Defined by attributes
  typeaheadSource: ITypeaheadSource;
  typeaheadItemText: string;
  placeholder: string;
  matchPrefixesOnly: boolean;
  withCounts: boolean;

  // Internal
  width: number;  // Used to match drop-down width to control width
  items: ISliceable<any>;
  itemText: (item: any) => string;
}

interface ITypeaheadAttributes extends ng.IAttributes {
  ngModel: string;
  typeaheadItemText: string;
  typeaheadPlaceholder: string;
  typeaheadMatchPrefixesOnly: string;
  typeaheadWithCounts: string;
  typeaheadSource: string;
}

class TypeaheadColumnWidths implements IColumnWidths {

  constructor(private widths: number[] = []) {
  }

  getActual(index: number) {
    return this.widths[index];
  }

  //Assumes 1 or 2 columns, expands the first cell to fill the total remaining space
  setWidths(widths: number[], totalWidth: number) {
    const firstCellWidth = totalWidth - (widths[1] || 0);
    this.widths = [ firstCellWidth ].concat(widths.slice(1));
  }

}

Module.instance().directive('tbTypeahead', [
  '$timeout',                   '$parse',
  ($timeout: ng.ITimeoutService, $parse: ng.IParseService) => {
    return {
      restrict: 'E',
      templateUrl: 'typeahead.html',
      replace: true,
      // Commented properties are read from directive attributes and added to the scope in the link function
      scope: {
        model: '=ngModel',
        autoEdit: '=',
        typeaheadItemText: '@'
        //typeaheadSource: '@',
        //matchPrefixesOnly: '@typeaheadMatchPrefixesOnly',
        //withCounts: '@typeaheadWithCounts'
      },
      link: {
        pre: (scope:ITypeaheadScope, element:JQuery, attributes:ITypeaheadAttributes) => {
          scope.placeholder = $parse(attributes.typeaheadPlaceholder)(scope.$parent);
          scope.matchPrefixesOnly = attributes.typeaheadMatchPrefixesOnly === 'true';
          scope.withCounts = attributes.typeaheadWithCounts === 'true';
          scope.typeaheadSource = $parse(attributes.typeaheadSource)(scope.$parent);
        },
        post: (scope:ITypeaheadScope, element:JQuery, attributes:ITypeaheadAttributes) => {

          scope.itemText = (model: any) => {
            return model ? model[scope.typeaheadItemText] : (scope.placeholder || '');
          };

          const rowToModel = (row: any) => {
            if (!row) throw new Error('No row is selected');
            return row;
          };

          DropdownHelper.setupDropdownScope<any, any>(scope, $timeout, element.find('input'), rowToModel);

          scope.$watch('textValue', (value: string) => {
            if (scope.editMode) {
              scope.items = scope.typeaheadSource(value);

              if (value) {
                scope.currentRow.index = 0;
              } else {
                scope.currentRow.index = -1;
              }
            }
          });

          scope.$watch('editMode', (editMode: boolean) => {
            if (editMode) {
              scope.width = element.width();

              scope.items = scope.typeaheadSource(scope.textValue);

              scope.columnWidths = new TypeaheadColumnWidths();
            }
          });

          scope.$watch('autoEdit', (autoEdit: boolean) => {
            if (autoEdit) {
              scope.edit();
            }
          });
        }
      }
    };
  }
]);
